// extracted by mini-css-extract-plugin
module.exports = {"tiny":"FYERE1jMes-button-size-tiny-tiny","circle":"_2RgC8YRZrM-button-size-tiny-circle","pill":"sGga7V42uE-button-size-tiny-pill"};